
class LemonhcModal{
    constructor(options){
        this.ctx = LemonhcRouter.contextPath;
        this.options = LemonhcUtils.deepExtend(this.defaults(), options);
        this.el.container = this.options.target;
        this.parse();
        return this;
    }
    el = {
        set container(target){
            if(target){
                this._container = target;
                this.haader = target.find('.modal-header');
                this.content = target.find('.modal-content');
                this.body = target.find('.modal-body');
                this.footer = target.find('.modal-footer');
                this.confirm = target.find('.modal-confirm');
                this.cancel = target.find('.modal-cancel');
                this.check = target.find('.modal-check'); //다시보지않기 체크 추가
            }
        },
        get container(){
            return this._container;
        }
    }
    show(){
        this.el.container.modal({backdrop: this.options.backdrop, show: true});
        if(window.modalStack.findIndex(v=> v.el[0] == $(`#${this.options.id}`)[0]) == -1){
            window.modalStack.push({el: this.el.container, data:{show: true}});
            $(`#${this.options.id}`).on('hidden.bs.modal', function (e) {
                window.modalStack.pop();
            });
        }
        return this;
    }
    hide(){
        if(window.modalStack.findIndex(v=> v.el[0] == $(`#${this.options.id}`)[0]) > -1){
            window.modalStack.pop();
        }
        this.el.container.modal('hide');
    }
    getContainer(){
        return `<div class="modal fade ${this.options.style.container}" id=${this.options.id} aria-modal="true" role="dialog" aria-labelledby="Modal" aria-hidden="true"></div>`;
    }
    getTemplate(){
        return `<div class="modal-dialog ${this.options.style.modal}">
                    <div class="modal-content ${this.options.style.content} "> 
                        ${this.options.header ? `${this.getHeaderTemplate()}`:''}
                      <div class="modal-body  ${this.options.style.body} ${this.options.scroll.enabled? 'scroll-on': ''}" >
                      </div> 
                      
                         ${this.getBtnTemplate()} 
                         <!--다시보지않기-->
                      ${this.options.check? `<div class="modal-check icheck-primary m-2 ${this.options.style.check}">
                        <input type="checkbox" class="" id="${this.options.attr}" /> <label for="${this.options.attr}" class="check-label">${this.options.text.check}</label>
                    </div> `:''}
                    </div>
                    
                  </div>`;
    }
    getHeaderTemplate(){
        let snuh = sessionStorage.getItem('snuh');

        return `<div class="modal-header  ${this.options.style.header} ${this.options.title=='NONE'? 'bd-0':''} ${snuh?'cha_modal__snuh':''}"> 
                    ${this.options.pully ? '<div class="cha_modal"></div>':''}
                    
                    ${this.options.title=='NONE'? '':`${this.options.title}`} 
                    
                    ${this.options.close ? `<button type="button" class="close" data-dismiss="modal"> <span aria-hidden="true"></span></button>` : ''}
                    
                </div>`;


    }
    getBtnTemplate(){
        return `                
                <div class="modal-footer ${this.options.style.footer}"> 
                
                    ${this.options.cancel? `<button type="button" class="modal-cancel ${this.options.style.cancel}" ${this.options.dismiss.cancel ? 'data-dismiss="modal"' : ''}>${this.options.text.cancel}</button>` : ''} 
                    ${this.options.confirm? `<button type="button" class="modal-confirm ${this.options.style.confirm}"  ${this.options.dismiss.confirm ? 'data-dismiss="modal"' : ''}>${this.options.text.confirm}</button> `:''}
                    
                </div>`
    }
    parse(){
        return new Promise((resolve, reject) => {
            try{
                let target = $('#'+ this.options.id);
                if(target.length < 1){
                    // modal 을 준비한다
                    target = $(this.getContainer());
                    // template을 가져온다.
                    let template = this.getTemplate();
                    target.html(template);
                    this.el.container = target;

                    // modal 에 들어갈 contents 를 셋팅 해 준다.
                    if(typeof this.options.body === 'string'){
                        this.el.body.prepend(this.options.body);
                    }else if(typeof this.options.body === 'object' && this.options.body instanceof jQuery){
                        this.el.body.prepend(this.options.body);
                    }
                    if(this.options.cancel){
                        this.el.cancel.on('click', this.options.fn.cancel);
                    }
                    if(this.options.confirm){
                        this.el.confirm.on('click', this.options.fn.confirm);
                    }

                    //다시보지않기 체크 추가
                    if(this.options.check){
                        this.el.check.on('change', this.options.fn.check);
                    }

                    /**
                     * modal 닫을 때 마다 없앨 껀지?
                     */
                    if(this.options.detach){
                        this.el.container.on('hidden.bs.modal', function (e) {
                            $(this).detach();
                        })
                    }

                    this.el.container.data('lemonhcModal', this);

                    if(this.options.attr){
                        // data 가 있으면 넣어줘야함..
                        this.el.container.attr(this.options.attr);
                    }
                    $('body').append(this.el.container);
                }else{
                    this.el.container = target;
                }
                resolve();
            }catch(e){
                reject(e);
            }
        });
    }
    defaults() {
        return {
            id: 'lemonhc-modal_' + new Date().getTime(),
            title: '알림',
            header:false,
            body: '컨텐츠를 입력해주세요.',
            detach: true,
            close: false,
            cancel: true,
            confirm: true,
            check: false, //다시보지않기 체크 추가 //기본 false, 사용할 모달에만 따로 true
            pully: false,
            backdrop: 'static', // true, false, static
            dismiss: {
                cancel: true,
                confirm: true,
            },
            attr: {

            },
            style: {
                container: 'modal-renewal',
                modal: 'modal-dialog-centered',
                content: 'no_bder',
                header: 'dis_Block text-center fs-14 fw-700 pa12',
                body: '',
                footer: 'border-light',
                confirm: 'text-02',
                cancel: 'text-01',
                check: 'mx-3' //다시보지않기 체크 css
            },
            scroll: {
                enabled: false,
                height: '400px'
            },
            text: {
                cancel : '취소',
                confirm : '확인',
                check:'다시보지 않기'
            },
            fn: {
                cancel: function(){
                    console.log(this.id + 'dismiss');
                },
                confirm: function(){
                    console.log(this.id+ 'dismiss');
                },
                check: function(){ //다시보지않기 function
                    console.log(this.id+ 'dismiss');
                }
            },

        };
    }
}


class LemonhcAlert extends LemonhcModal{
    constructor(header, text, action, btn_text, config){
        let alertOptions = {
            header:false,
            title:header?header: '알림',
            body: '<span>'+text+'</span>',
            dismiss: {
                confirm: true,
                close: true
            },
            confirm: true,
            cancel: false,
            text:{
                confirm: btn_text || '확인'
            },
            style: {
                confirm: 'text-02 w-100',
            },
            fn: {
                confirm: action,
            }
        }
        let options = LemonhcUtils.deepExtend(alertOptions, config||{});
        super(alertOptions);
        return this;
    }
}


class LemonhcAlertLight extends LemonhcAlert{
    constructor(header, text, action, btn_text, config){
        super(header,text,action,btn_text,config);
    }
}

class LemonhcConfirm extends LemonhcModal{
    constructor(header, body, action, btn_text, config){
        if(typeof btn_text === 'string'){
            btn_text = {
                confirm: btn_text
            };
        }
        if(typeof action === 'function'){
            action = {
                confirm: action
            };
        }
        if (typeof body === 'function'){
            body = body();
        }

        let confirmOptions = {
            header:false,
            title:header?header : '알림',
            body: body,
            dismiss: {
                confirm: true,
                cancel: true
            },
            style: {
                confirm: 'text-09',
                cancel: 'text-01'
            },
            confirm: true,
            cancel: true
        }
        if(action&&action.confirm){
            confirmOptions.fn = action;
        }
        if(btn_text){
            confirmOptions.text = btn_text;
        }

        let options = LemonhcUtils.deepExtend(confirmOptions, config||{});
        super(confirmOptions);
        return this;
    }
}



class LemonhcInfo extends LemonhcAlert{
    constructor(header, text, action, btn_text, config){
        super(header,text,action,btn_text,config);
    }
    getBtnTemplate(){
        return '';
    }
}

let Modal = {
    default: LemonhcModal,
    confirm: LemonhcConfirm,
    alert: LemonhcAlert,
    alertLight: LemonhcAlertLight,
    info: LemonhcInfo,
}

export {Modal};
